import { __rest, __assign } from 'tslib';
import React, { forwardRef, useContext, useRef, useState } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { Comment } from '../../comment/esm';
import { useFocus } from '@alfalab/hooks';
import { getDataTestId } from '../../shared/esm';
import { Amount as Amount$1 } from '../../amount/esm';
import { Text as Text$1, TitleResponsive } from '../../typography/esm';
import { Button } from '../../button/esm';

var styles$a = {"component":"pure-cell__component_vnjkt","none":"pure-cell__none_vnjkt","default":"pure-cell__default_vnjkt","addonPadding":"pure-cell__addonPadding_vnjkt","auto":"pure-cell__auto_vnjkt","top":"pure-cell__top_vnjkt","center":"pure-cell__center_vnjkt","bottom":"pure-cell__bottom_vnjkt","button":"pure-cell__button_vnjkt"};
require('./components/addon/index.css');

var ADDON_COMPONENT = {
    button: 'button',
    section: 'section',
};
var Addon = function (_a) {
    var _b;
    var children = _a.children, _c = _a.verticalAlign, verticalAlign = _c === void 0 ? 'top' : _c, _d = _a.addonPadding, addonPadding = _d === void 0 ? 'default' : _d, dataTestId = _a.dataTestId, onClick = _a.onClick;
    var pureCellContext = useContext(PureCellContext);
    var Component = onClick ? ADDON_COMPONENT.button : ADDON_COMPONENT.section;
    var onMouseEvents = {
        onClick: function (e) {
            e.stopPropagation();
            onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        onMouseEnter: function () {
            var _a;
            (_a = pureCellContext.unsetMainHover) === null || _a === void 0 ? void 0 : _a.call(pureCellContext);
        },
        onMouseLeave: function () {
            var _a;
            (_a = pureCellContext.setMainHover) === null || _a === void 0 ? void 0 : _a.call(pureCellContext);
        },
        onMouseDown: function (e) {
            e.stopPropagation();
        },
    };
    return (React.createElement(Component, __assign({ className: cn(styles$a.component, styles$a[addonPadding], styles$a[verticalAlign], (_b = {},
            _b[styles$a.button] = onClick,
            _b)), "data-test-id": getDataTestId(dataTestId || pureCellContext.dataTestId, 'addon') }, (onClick && onMouseEvents)), children));
};

var styles$9 = {"component":"pure-cell__component_iav5u","hidden":"pure-cell__hidden_iav5u","hiddenWrapper":"pure-cell__hiddenWrapper_iav5u"};
require('./components/amount/index.css');

var Amount = function (_a) {
    var _b = _a.weight, weight = _b === void 0 ? 'normal' : _b, _c = _a.textView, textView = _c === void 0 ? 'component' : _c, _d = _a.color, color = _d === void 0 ? 'primary' : _d, minority = _a.minority, _e = _a.minorUnits, minorUnits = _e === void 0 ? 100 : _e, hidden = _a.hidden, dataTestId = _a.dataTestId, restProps = __rest(_a, ["weight", "textView", "color", "minority", "minorUnits", "hidden", "dataTestId"]);
    var pureCellContext = useContext(PureCellContext);
    if (hidden) {
        return (React.createElement("div", { className: styles$9.hiddenWrapper },
            React.createElement("div", { className: styles$9.hidden })));
    }
    return (React.createElement(Text$1, { view: textView, dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'amount-text'), className: cn(styles$9.component), color: color },
        React.createElement(Amount$1, __assign({ minority: minority || minorUnits, bold: weight === 'bold' ? 'full' : 'none', dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'amount') }, restProps))));
};

var styles$8 = {"component":"pure-cell__component_1gjon","weight":"pure-cell__weight_1gjon","hidden":"pure-cell__hidden_1gjon","hidden-xsmall":"pure-cell__hidden-xsmall_1gjon","hidden-small":"pure-cell__hidden-small_1gjon","hidden-medium":"pure-cell__hidden-medium_1gjon","hidden-large":"pure-cell__hidden-large_1gjon","hidden-xlarge":"pure-cell__hidden-xlarge_1gjon","hiddenWrapper":"pure-cell__hiddenWrapper_1gjon","hiddenWrapper-xsmall":"pure-cell__hiddenWrapper-xsmall_1gjon","hiddenWrapper-small":"pure-cell__hiddenWrapper-small_1gjon","hiddenWrapper-medium":"pure-cell__hiddenWrapper-medium_1gjon","hiddenWrapper-large":"pure-cell__hiddenWrapper-large_1gjon","hiddenWrapper-xlarge":"pure-cell__hiddenWrapper-xlarge_1gjon"};
require('./components/amount-title/index.css');

var AmountTitle = function (_a) {
    var minority = _a.minority, _b = _a.minorUnits, minorUnits = _b === void 0 ? 100 : _b, hidden = _a.hidden, className = _a.className, _c = _a.color, color = _c === void 0 ? 'primary' : _c, dataTestId = _a.dataTestId, _d = _a.titleProps, titlePropsFromProps = _d === void 0 ? {} : _d, restProps = __rest(_a, ["minority", "minorUnits", "hidden", "className", "color", "dataTestId", "titleProps"]);
    var pureCellContext = useContext(PureCellContext);
    var titleProps = __assign({ tag: 'h4', view: 'small', color: color }, titlePropsFromProps);
    if (hidden) {
        return (React.createElement("div", { className: cn(styles$8.hiddenWrapper, styles$8["hiddenWrapper-".concat(titleProps.view)]) },
            React.createElement("div", { className: cn(styles$8.hidden, styles$8["hidden-".concat(titleProps.view)]) })));
    }
    return (React.createElement(TitleResponsive, __assign({}, titleProps, { dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'amount-title'), className: cn(styles$8.component, titlePropsFromProps === null || titlePropsFromProps === void 0 ? void 0 : titlePropsFromProps.className) }),
        React.createElement(Amount$1, __assign({ minority: minority || minorUnits, className: cn(styles$8.weight, className), dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'core-amount-title') }, restProps, { bold: 'none' }))));
};

var styles$7 = {"component":"pure-cell__component_14y58","categoryName":"pure-cell__categoryName_14y58","categoryPercent":"pure-cell__categoryPercent_14y58","rightAddon":"pure-cell__rightAddon_14y58"};
require('./components/category/index.css');

var Category = function (_a) {
    var categoryName = _a.categoryName, categoryPercent = _a.categoryPercent, rightAddons = _a.rightAddons, dataTestId = _a.dataTestId;
    var pureCellContext = useContext(PureCellContext);
    return (React.createElement("div", { className: styles$7.component, "data-test-id": 'cell-pure-category' },
        React.createElement(Text$1, { view: 'primary-small', color: 'secondary', dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'category-name'), className: styles$7.categoryName }, categoryName),
        categoryPercent !== undefined && (React.createElement(Text$1, { tag: 'div', view: 'primary-small', color: 'secondary', className: styles$7.categoryPercent, dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'category-percent') },
            categoryPercent,
            "%")),
        rightAddons !== undefined && (React.createElement("div", { className: styles$7.rightAddon, "data-test-id": getDataTestId(dataTestId || pureCellContext.dataTestId, 'category-right-addon') }, rightAddons))));
};

var styles$6 = {"component":"pure-cell__component_1anf0","horizontal":"pure-cell__horizontal_1anf0"};
require('./components/content/index.css');

var Content = function (_a) {
    var _b;
    var children = _a.children, dataTestId = _a.dataTestId;
    var _c = useContext(PureCellContext), direction = _c.direction, contextDataTestId = _c.dataTestId;
    return (React.createElement("section", { className: cn(styles$6.component, (_b = {}, _b[styles$6.horizontal] = direction === 'horizontal', _b)), "data-test-id": getDataTestId(dataTestId || contextDataTestId, 'content') }, children));
};

var styles$5 = {"component":"pure-cell__component_1qfbe","none":"pure-cell__none_1qfbe","default":"pure-cell__default_1qfbe"};
require('./components/footer/index.css');

var Footer = function (_a) {
    var children = _a.children, _b = _a.footerPadding, footerPadding = _b === void 0 ? 'default' : _b, dataTestId = _a.dataTestId;
    var pureCellContext = useContext(PureCellContext);
    return (React.createElement("footer", { className: cn(styles$5.component, styles$5[footerPadding]), "data-test-id": getDataTestId(dataTestId || pureCellContext.dataTestId, 'footer') }, children));
};

var styles$4 = {"component":"pure-cell__component_1heph"};
require('./components/footer-button/index.css');

var FooterButton = forwardRef(function (_a, ref) {
    var children = _a.children, dataTestId = _a.dataTestId, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, props = __rest(_a, ["children", "dataTestId", "onClick", "onMouseDown", "onMouseEnter", "onMouseLeave"]);
    var pureCellContext = useContext(PureCellContext);
    var handleClick = function (e) {
        e.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    var handleMouseEnter = function (e) {
        var _a;
        onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(e);
        (_a = pureCellContext.unsetMainHover) === null || _a === void 0 ? void 0 : _a.call(pureCellContext);
    };
    var handleMouseLeave = function (e) {
        var _a;
        onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(e);
        (_a = pureCellContext.setMainHover) === null || _a === void 0 ? void 0 : _a.call(pureCellContext);
    };
    var handleMouseDown = function (e) {
        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
        e.stopPropagation();
    };
    return (React.createElement(Button, __assign({}, props, { size: 'xxs', dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'button'), className: styles$4.component, ref: ref, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onMouseDown: handleMouseDown }), children));
});

var FooterText = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? 'secondary' : _b, dataTestId = _a.dataTestId;
    var pureCellContext = useContext(PureCellContext);
    return (React.createElement(Text$1, { view: 'primary-small', color: color, "data-test-id": getDataTestId(dataTestId || pureCellContext.dataTestId, 'footer-title') }, children));
};

var styles$3 = {"component":"pure-cell__component_fwmmy","top":"pure-cell__top_fwmmy","center":"pure-cell__center_fwmmy","bottom":"pure-cell__bottom_fwmmy","horizontal":"pure-cell__horizontal_fwmmy","none":"pure-cell__none_fwmmy","airy":"pure-cell__airy_fwmmy","default":"pure-cell__default_fwmmy","compact":"pure-cell__compact_fwmmy","tiny":"pure-cell__tiny_fwmmy","vertical":"pure-cell__vertical_fwmmy","button":"pure-cell__button_fwmmy"};
require('./components/graphics/index.css');

var GRAPHICS_COMPONENT = {
    button: 'button',
    section: 'section',
};
var Graphics = function (_a) {
    var _b;
    var children = _a.children, dataTestId = _a.dataTestId, _c = _a.verticalAlign, verticalAlign = _c === void 0 ? 'top' : _c, graphicPadding = _a.graphicPadding, onClick = _a.onClick;
    var pureCellContext = useContext(PureCellContext);
    var Component = onClick ? GRAPHICS_COMPONENT.button : GRAPHICS_COMPONENT.section;
    var defaultGraphicPadding = pureCellContext.direction === 'horizontal' ? 'airy' : 'default';
    var onMouseEvents = {
        onClick: function (e) {
            e.stopPropagation();
            onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        onMouseEnter: function () {
            var _a;
            (_a = pureCellContext.unsetMainHover) === null || _a === void 0 ? void 0 : _a.call(pureCellContext);
        },
        onMouseLeave: function () {
            var _a;
            (_a = pureCellContext.setMainHover) === null || _a === void 0 ? void 0 : _a.call(pureCellContext);
        },
        onMouseDown: function (e) {
            e.stopPropagation();
        },
    };
    return (React.createElement(Component, __assign({ className: cn(styles$3.component, styles$3[verticalAlign], styles$3[pureCellContext.direction || 'horizontal'], styles$3[graphicPadding || defaultGraphicPadding], (_b = {}, _b[styles$3.button] = onClick, _b)), "data-test-id": getDataTestId(dataTestId || pureCellContext.dataTestId, 'graphics') }, (onClick && onMouseEvents)), children));
};

var styles$2 = {"component":"pure-cell__component_kgj7j","vertical":"pure-cell__vertical_kgj7j","reverse":"pure-cell__reverse_kgj7j","button":"pure-cell__button_kgj7j"};
require('./components/main/index.css');

var MAIN_COMPONENT = {
    button: 'button',
    section: 'section',
};
var Main = function (_a) {
    var _b, _c;
    var children = _a.children, isReverse = _a.isReverse, className = _a.className, dataTestId = _a.dataTestId, onClick = _a.onClick;
    var _d = useContext(PureCellContext), _e = _d.direction, direction = _e === void 0 ? 'horizontal' : _e, contextDataTestId = _d.dataTestId, setMainHover = _d.setMainHover, unsetMainHover = _d.unsetMainHover;
    var Component = onClick ? MAIN_COMPONENT.button : MAIN_COMPONENT.section;
    var onMouseEvents = {
        onClick: function (e) {
            e.stopPropagation();
            onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        onMouseEnter: function () {
            unsetMainHover === null || unsetMainHover === void 0 ? void 0 : unsetMainHover();
        },
        onMouseLeave: function () {
            setMainHover === null || setMainHover === void 0 ? void 0 : setMainHover();
        },
        onMouseDown: function (e) {
            e.stopPropagation();
        },
    };
    return (React.createElement(Component, __assign({ className: cn(styles$2.component, styles$2[direction], (_b = {},
            _b[styles$2.reverse] = isReverse,
            _b), (_c = {}, _c[styles$2.button] = onClick, _c), className), "data-test-id": getDataTestId(dataTestId || contextDataTestId, 'main') }, (onClick && onMouseEvents)), children));
};

var styles$1 = {"horizontal":"pure-cell__horizontal_vbzkz","rowLimit1":"pure-cell__rowLimit1_vbzkz","rowLimit2":"pure-cell__rowLimit2_vbzkz","component":"pure-cell__component_vbzkz","vertical":"pure-cell__vertical_vbzkz","title":"pure-cell__title_vbzkz","value":"pure-cell__value_vbzkz"};
require('./components/text/index.css');

var Text = function (_a) {
    var _b;
    var children = _a.children, value = _a.value, rowLimit = _a.rowLimit, _c = _a.view, view = _c === void 0 ? 'component-primary' : _c, titleWeight = _a.titleWeight, titleColor = _a.titleColor, valueColor = _a.valueColor, dataTestId = _a.dataTestId;
    var _d = useContext(PureCellContext), _e = _d.direction, direction = _e === void 0 ? 'horizontal' : _e, contextDataTestId = _d.dataTestId;
    var className = rowLimit && styles$1["rowLimit".concat(rowLimit)];
    return (React.createElement("div", { className: cn(styles$1.component, (_b = {},
            _b[styles$1.vertical] = direction !== 'horizontal',
            _b)) },
        React.createElement("div", { className: styles$1.title },
            React.createElement(Text$1, { view: view, weight: titleWeight, tag: 'div', color: titleColor, className: className, "data-test-id": getDataTestId(dataTestId || contextDataTestId, 'text_content') }, children)),
        value && (React.createElement("div", { className: styles$1.value },
            React.createElement(Text$1, { view: view, tag: 'div', color: valueColor, className: className, "data-test-id": getDataTestId(dataTestId || contextDataTestId, 'text_value') }, value)))));
};

var styles = {"component":"pure-cell__component_1nzbu","horizontal":"pure-cell__horizontal_1nzbu","vertical":"pure-cell__vertical_1nzbu","button":"pure-cell__button_1nzbu","hover":"pure-cell__hover_1nzbu","active":"pure-cell__active_1nzbu","link":"pure-cell__link_1nzbu","none":"pure-cell__none_1nzbu","airy":"pure-cell__airy_1nzbu","default":"pure-cell__default_1nzbu","compact":"pure-cell__compact_1nzbu","tiny":"pure-cell__tiny_1nzbu","noneTop":"pure-cell__noneTop_1nzbu","airyTop":"pure-cell__airyTop_1nzbu","defaultTop":"pure-cell__defaultTop_1nzbu","compactTop":"pure-cell__compactTop_1nzbu","tinyTop":"pure-cell__tinyTop_1nzbu","noneBottom":"pure-cell__noneBottom_1nzbu","airyBottom":"pure-cell__airyBottom_1nzbu","defaultBottom":"pure-cell__defaultBottom_1nzbu","compactBottom":"pure-cell__compactBottom_1nzbu","tinyBottom":"pure-cell__tinyBottom_1nzbu","left":"pure-cell__left_1nzbu","right":"pure-cell__right_1nzbu","both":"pure-cell__both_1nzbu","focused":"pure-cell__focused_1nzbu"};
require('./index.css');

// eslint-disable-next-line @typescript-eslint/no-redeclare
var PureCellContext = React.createContext({});
var PureCellComponent = forwardRef(function (_a, ref) {
    var _b, _c;
    var className = _a.className, dataTestId = _a.dataTestId, onClick = _a.onClick, href = _a.href, _d = _a.tag, Component = _d === void 0 ? (href && 'a') || (onClick && 'button') || 'section' : _d, children = _a.children, _e = _a.horizontalPadding, horizontalPadding = _e === void 0 ? 'none' : _e, _f = _a.verticalPadding, verticalPadding = _f === void 0 ? 'none' : _f, _g = _a.direction, direction = _g === void 0 ? 'horizontal' : _g, restProps = __rest(_a, ["className", "dataTestId", "onClick", "href", "tag", "children", "horizontalPadding", "verticalPadding", "direction"]);
    var cellRef = useRef(null);
    var focused = useFocus(cellRef, 'keyboard')[0];
    var _h = useState(false), hoverState = _h[0], setHoverState = _h[1];
    var _j = useState(false), activeState = _j[0], setActiveState = _j[1];
    var setHover = function () { return setHoverState(true); };
    var unsetHover = function () { return setHoverState(false); };
    var setActive = function () { return setActiveState(true); };
    var unsetActive = function () { return setActiveState(false); };
    var mouseEvents = {
        onMouseEnter: setHover,
        onMouseLeave: unsetHover,
        onMouseDown: setActive,
        onMouseUp: unsetActive,
    };
    var addClasses = (_b = {},
        _b[styles.component] = true,
        _b[styles.focused] = focused,
        _b[styles[direction]] = true,
        _b[styles[horizontalPadding]] = true,
        _b[styles.hover] = hoverState,
        _b[styles.active] = activeState,
        _b);
    var contextState = {
        direction: direction,
        dataTestId: dataTestId,
        setMainHover: setHover,
        unsetMainHover: unsetHover,
    };
    if (typeof verticalPadding === 'string') {
        addClasses[styles[verticalPadding]] = typeof verticalPadding === 'string';
    }
    if (typeof verticalPadding === 'object') {
        addClasses[styles["".concat(verticalPadding.top, "Top")]] = !!verticalPadding.top;
        addClasses[styles["".concat(verticalPadding.bottom, "Bottom")]] = !!verticalPadding.bottom;
    }
    if (href) {
        var target = restProps.target;
        // Для совместимости с react-router-dom, меняем href на to
        var hrefProps = (_c = {}, _c[typeof Component === 'string' ? 'href' : 'to'] = href, _c);
        return (React.createElement(Component, __assign({ rel: target === '_blank' ? 'noreferrer noopener' : undefined }, restProps, hrefProps, { ref: mergeRefs([cellRef, ref]), className: cn(styles.link, addClasses, className), "data-test-id": dataTestId, onClick: onClick }, mouseEvents),
            React.createElement(PureCellContext.Provider, { value: contextState }, children)));
    }
    if (onClick) {
        return (React.createElement(Component, __assign({}, restProps, { ref: mergeRefs([cellRef, ref]), className: cn(styles.button, addClasses, className), "data-test-id": dataTestId, onClick: onClick }, mouseEvents),
            React.createElement(PureCellContext.Provider, { value: contextState }, children)));
    }
    return (React.createElement(Component, __assign({}, restProps, { ref: ref, tabIndex: 0, className: cn(addClasses, className), "data-test-id": dataTestId }),
        React.createElement(PureCellContext.Provider, { value: contextState }, children)));
});
var ExtraSubtitle = FooterText;
/**
 * Универсальный конструктор для сборки любой ячейки.
 *
 * [Макет](https://www.figma.com/file/KlFOLLkKO8rtvvQE3RXuhq/Click-Library?node-id=43525%3A240018)
 */
var PureCell = Object.assign(PureCellComponent, {
    Main: Main,
    Graphics: Graphics,
    Content: Content,
    Text: Text,
    Amount: Amount,
    AmountTitle: AmountTitle,
    Addon: Addon,
    Footer: Footer,
    ExtraSubtitle: ExtraSubtitle,
    FooterButton: FooterButton,
    Comment: Comment,
    Category: Category,
});
PureCellComponent.displayName = 'PureCellComponent';

export { Amount as A, Content as C, ExtraSubtitle as E, Footer as F, Graphics as G, Main as M, PureCell as P, Text as T, PureCellComponent as a, AmountTitle as b, Addon as c, FooterButton as d, Category as e, FooterText as f, PureCellContext as g };
